import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./style.module.css";
import { HeaderSide } from "./headerside";
import { MapWithPoligons } from "../../MapWithPoligons";
import L from "leaflet";
import { EntAnaliticalDataTLCFilter } from "./api/types";
import { Select } from "antd";
import { useGetAllDataOfTLCListQuery, useGetAnaliticalDataCapacityTLCListQuery, useGetAnaliticalDataStatusTLCListQuery } from "./api";
import { PreloaderSvg } from "../../preloaderSvg/PreloaderSvg";
import { RightTable } from "./rightTable";
import SelectTerritorialUnitsCode from "../../selects/SelectTerritorialUnitsCode";
import { LeftGraph } from "./LeftGraph";
import { SecondGraph } from "./secondGraph";

const customMarkerIcon = L.icon({
  iconUrl: "/imort.svg",
  iconSize: [35, 55],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const TLCOrganic = () => {
  const { t } = useTranslation();

  const [filters, setFilters] = useState<EntAnaliticalDataTLCFilter>({
    year: 2025,
    page: 1,
    size: 10000,
  });

  const { data: tlcData, isLoading: tlcLoading } = useGetAllDataOfTLCListQuery(filters);
  const { data: tlcCapacityData, isLoading: tlcCapacityLoading } = useGetAnaliticalDataCapacityTLCListQuery(filters);
  const { data: tlcStatusData, isLoading: tlcStatusLoading } = useGetAnaliticalDataStatusTLCListQuery(filters);


  const handleRegionChange = (regionId: string | number, option?: any) => {
    const numericRegionId = typeof regionId === 'string' ? parseInt(regionId, 10) : regionId;
    
    if (numericRegionId === 0) {
      setFilters((prev) => {
        const newFilters = { ...prev };
        delete newFilters.regionId;
        return { ...newFilters, page: 1 };
      });
    } else {
      setFilters((prev) => ({
        ...prev,
        regionId: numericRegionId,
        page: 1,
      }));
    }
  };

  const handlePolygonClick = (regionId: number) => {
    setFilters((prev) => ({
      ...prev,
      regionId,
      page: 1,
    }));
  };
  const handleYearChange = (year: number | null) => {
    setFilters((prev) => ({
      ...prev,
      year: year || new Date().getFullYear(),
      page: 1,
    }));
  };

  const handleResetFilters = () => {
    setFilters({
      year: 2025,
      page: 1,
      size: 1000
    });
  };

  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

  const mapData = React.useMemo(() => {
    if (!tlcData?.success || !tlcData?.res?.content) {
      return [];
    }

    return tlcData.res.content.map((tlc) => ({
      latitude: tlc.latitude,
      longitude: tlc.longitude,
      name: tlc.centerName,
      address: `${tlc.region?.nameRu || 'Не указан'}, ${tlc.area?.nameRu || 'Не указан'}`,
      type: "Торгово-логистический центр",
      popupContent: `
        <div style="padding: 8px;">
          <h4 style="margin: 0 0 8px 0; color: #333; font-size: 16px;">
            ${tlc.centerName || 'Без названия'}
          </h4>
          <p style="margin: 4px 0; color: #666;">
            <strong style="color: #333;">Регион:</strong> ${tlc.region?.nameRu || 'Не указан'}
          </p>
          <p style="margin: 4px 0; color: #666;">
            <strong style="color: #333;">Район:</strong> ${tlc.area?.nameRu || 'Не указан'}
          </p>
          <p style="margin: 4px 0; color: #666;">
            <strong style="color: #333;">Владелец:</strong> ${tlc.owner || 'Не указан'}
          </p>
          <p style="margin: 4px 0; color: #666;">
            <strong style="color: #333;">Статус:</strong> ${tlc.registerStatus?.nameRu || 'Не указан'}
          </p>
          <p style="margin: 4px 0; color: #666;">
            <strong style="color: #333;">Площадь хранения:</strong> ${tlc.capacity?.[0]?.storageAreaM2 || 0} м²
          </p>
          <p style="margin: 4px 0; color: #666;">
            <strong style="color: #333;">Холодильные камеры:</strong> ${tlc.capacity?.[0]?.coldStorageVolumeM3 || 0} м³
          </p>
        </div>
      `
    }));
  }, [tlcData]);


  const regionName = tlcData?.res?.content?.[0]?.region?.nameRu || "-";

  const organizations = tlcData?.res?.content?.map(tlc => tlc.centerName) || [];

  return (
    <div>
      <HeaderSide />
      <div className={style.container}>
        <div className={style.flexRow}>
          <div className={style.content}>
            <div className={style.mapContent}>
              <div className={style.mapFiltersOnMap}>
                <Select
                  style={{ width: 120 }}
                  value={filters.year}
                  onChange={handleYearChange}
                  placeholder={t("Выберите год")}
                >
                  {years.map((year) => (
                    <Select.Option key={year} value={year}>
                      {year}
                    </Select.Option>
                  ))}
                </Select>
             
                <SelectTerritorialUnitsCode
                type={["REGION"]}
                value={filters.regionId}
                onChange={handleRegionChange}
              />
                 <button className={style.resetBtn} onClick={handleResetFilters}>
                  Сбросить
                </button>
              </div>
              <MapWithPoligons
                latitude={41.5089324}
                longitude={74.724091}
                customIcon={customMarkerIcon}
                type={["REGION"]}
                selectedYear={filters.year}
                extraData={mapData}
              />
            </div>
          </div>
          <RightTable regionName={regionName} organizations={organizations} />
        </div>
        {(tlcLoading) && <PreloaderSvg />}
      </div>
      <div className={style.graphs}>
      <LeftGraph
  data={
    tlcCapacityData?.res
      ? {
          success: !!tlcCapacityData?.success,
          res: tlcCapacityData.res
        }
      : { success: false }
  }
  isLoading={tlcCapacityLoading}
  year={filters.year}
/>
<SecondGraph  data={
    tlcStatusData?.res
      ? {
          success: !!tlcStatusData?.success,
          res: tlcStatusData.res
        }
      : { success: false }
  }
  isLoading={tlcStatusLoading}
  year={filters.year} />
  </div>
    </div>
  );
};